
export default {
  name: 'CenterLayout'
};
